<template>
    <div id="main-side-nav">
        <!-- Logo -->
        <div class="sidebar-logo">
            <router-link :to="logoLink" class="logo-link">
                <img src="/img/brand/pc-dark.png" class="logo-img" :alt="currentProduct">
            </router-link>
        </div>

        <!-- Product Cloud Sidebar -->
        <ProductCloudSidebar v-if="currentProduct === 'productcloud'" />

        <!-- BankWatch Sidebar -->
        <BankWatchSidebar v-else-if="currentProduct === 'bankwatch'" />

        <!-- CDR Test Suite Sidebar -->
        <CdrTestSidebar v-else-if="currentProduct === 'cdrtest'" />
    </div>
</template>

<script lang="ts">
import { defineComponent, computed } from 'vue';
import store from '@/store';
import ProductCloudSidebar from './sidebars/ProductCloudSidebar.vue';
import BankWatchSidebar from './sidebars/BankWatchSidebar.vue';
import CdrTestSidebar from './sidebars/CdrTestSidebar.vue';

export default defineComponent({
    name: 'AppSidebar',
    components: {
        ProductCloudSidebar,
        BankWatchSidebar,
        CdrTestSidebar
    },
    setup() {
        const currentProduct = computed(() => store.state.currentProduct);

        const logoLink = computed(() => {
            if (currentProduct.value === 'bankwatch') return '/bankwatch/landing';
            if (currentProduct.value === 'cdrtest') return '/cdr-test/dashboard';
            return '/landing';
        });

        return {
            currentProduct,
            logoLink
        };
    }
});
</script>

<style lang="scss" scoped>
#main-side-nav {
    width: 80px;
    height: 100vh;
    background: white;
    border-right: 1px solid #e5e5e7;
    display: flex;
    flex-direction: column;
}

.sidebar-logo {
    padding: 20px 0;
    display: flex;
    justify-content: center;
    align-items: center;
    border-bottom: 1px solid #e5e5e7;
}

.logo-link {
    text-decoration: none;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 48px;
    height: 48px;
    border-radius: 12px;
    background: #007aff;
    transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);

    &:hover {
        background: #0051d5;
        transform: scale(1.05);
    }

    &:active {
        transform: scale(0.98);
    }
}

.logo-img {
    width: 32px;
    height: auto;
    display: block;
    filter: brightness(0) invert(1);
    transition: all 0.2s ease;
}
</style>
